import { useMutation, useQueryClient } from "@tanstack/react-query"

import { EMPLOYEE_QUERY_KEY } from "@/constants/query"
import { createEmployee, deleteEmployees, updateEmployee, changePasswordEmployee } from "@/http/employee"

import { useMessage } from "@/hook/useMessage"

export const useEmployeeMutation = () => {
  const client = useQueryClient()
  const { Success, Error, Process } = useMessage(EMPLOYEE_QUERY_KEY)

  const onSuccess = () => {
    client.invalidateQueries([EMPLOYEE_QUERY_KEY]).then()
    Success()
  }

  const onMutate = () => {
    Process()
  }

  const onError = (e: any) => {
    Error(e)
  }

  const createMutation = useMutation({
    mutationFn: createEmployee,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  const updateMutation = useMutation({
    mutationFn: updateEmployee,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  const deleteMutation = useMutation({
    mutationFn: deleteEmployees,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  const changePasswordMutation = useMutation({
    mutationFn: changePasswordEmployee,
    onSuccess: () => onSuccess(),
    onMutate: () => onMutate(),
    onError: (e) => onError(e)
  })

  return {
    createMutation,
    updateMutation,
    deleteMutation,
    changePasswordMutation
  }
}
